import React from "react";

interface ScoreOnlyDisplayProps {
  /** Hex color code (with #) */
  color: string;
  /** Text to display as the score */
  displayText: string;
  /** Optional label under the score (e.g., "out of 5") */
  label?: string;
}

const ScoreOnlyDisplay: React.FC<ScoreOnlyDisplayProps> = ({
  color,
  displayText,
  label,
}) => {
  return (
    <div className="w-full flex flex-col items-center justify-center px-4 py-8">
      {/* Enhanced pill badge with stronger presence */}
      <div
        className="rounded-[40px] px-10 py-12 flex items-center justify-center border-[3px] shadow-xl"
        style={{
          backgroundColor: `${color}15`,
          borderColor: `${color}40`,
        }}
      >
        <div className="relative flex items-center justify-center">
          <span className="text-6xl font-black leading-none" style={{ color }}>
            {displayText.includes("%")
              ? displayText.replace("%", "")
              : displayText}
          </span>
          {displayText.includes("%") && (
            <span
              className="absolute text-xl font-semibold opacity-40"
              style={{
                color,
                top: "0.25rem",
                right: "-1.25rem",
              }}
            >
              %
            </span>
          )}
        </div>
      </div>

      {/* Optional Label */}
      {label && (
        <p className="text-xs font-medium text-gray-600 mt-3">{label}</p>
      )}
    </div>
  );
};

export default ScoreOnlyDisplay;
